import { Search } from "lucide-react";
import "../css/GeneralCss.css";
import { useTranslation } from "react-i18next";

export const AttendanceSearchComponent = ({ onSearch }) => {
  const { t } = useTranslation();


  return (
      <div className="position-relative flex-grow-1 d-flex align-items-center">
        <div className="position-absolute top-50 start-0 translate-middle-y ps-3 text-secondary">
          <Search size={18} />
        </div>
        <input
          type="text"
          className="form-control ps-5 custom-placeholder"
          placeholder={t(`search.attendance`)}
          style={{
            backgroundColor: "#FCFAFA",
            borderColor: "black",
            borderRadius: "22px",
            padding: "10px 20px"
          }}
          onChange={(e)=>onSearch(e.target.value)}
        />
      </div>
  );
};
